import BG_DESKTOP from "./assets/images/bg.desktop.png";
import BG_MOBILE from "./assets/images/bg.mobile.webp";
import ALBUM_ART from "./assets/images/album art.webp";
import FESTIVAL_SEASON from "./assets/images/music/Festival Season.webp";
import COLLECTION_ONE from "./assets/images/music/Collection One.webp";
import GHETTO_LENNY from "./assets/images/music/Ghetto Lenny Love Songs.webp";
import WHILE_THE_WORLD from "./assets/images/music/While the World Was Burning.webp";

const MyAsset = {
  photoOptionImg:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/images/photo-option.png",
  videoOptionGIF:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/videos/video%20option.gif",
  videoOptionMP4:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/videos/video%20option.mp4",
  albumArt:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/images/feature.png",
  bgVideo:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/videos/bg-2.mp4",
  bgPoster:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/images/bg-2.png",
  unreleasedClip:
    "https://raw.githubusercontent.com/kevin700brands/saint-jhn-festival-assets/refs/heads/main/audio/clip-2.mp3",
  BG_DESKTOP,
  BG_MOBILE,
  ALBUM_ART,
  FESTIVAL_SEASON,
  COLLECTION_ONE,
  GHETTO_LENNY,
  WHILE_THE_WORLD,
};

export default MyAsset;
